import {
    FETCH_P24_TRANSACTION_LOGS
} from "../actions/actionTypes";

const defaultState = {
    //lista ze wszystkimi logami p24 wybranej transakcji
    p24TransactionLogList: []
};

export default function p24TransactionLogReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_P24_TRANSACTION_LOGS: {
            return {
                ...state,
                p24TransactionLogList: action.payload
            };
        }
        default:
            return state;
    }
}